import React from "react";
import { InteractiveContainer } from "@jugl-web/ui-kit";
import { Portal } from "@headlessui/react";

export const CXKnowledgeTrainingPopup: React.FC<{
  isOpen: boolean;
  title: string;
  img: React.ReactNode;
  subtitle: React.ReactNode;
  button: {
    text: string;
    onClick: () => void;
  };
}> = ({ isOpen, button, subtitle, title, img }) => {
  if (!isOpen) return null;
  return (
    <Portal>
      <div className="util-prevent-drawer-close fixed right-10 bottom-10 z-[51] w-[360px] animate-fade-in rounded-[20px] bg-[#333333]">
        <div className="flex items-center justify-between gap-3 border-0 border-b border-solid border-dark-800 py-[3px] pl-6">
          <span className="font-secondary text-lg leading-[140%] font-semibold text-white">
            {title}
          </span>
          {img}
        </div>
        <div className="px-6 py-2.5">
          <span className="font-secondary text-sm text-white">{subtitle}</span>
        </div>
        <div className="mx-6 mb-6 flex h-10 items-center justify-end px-2">
          <InteractiveContainer
            className="bg-[linear-gradient(149deg,#A9BDFF_68.46%,#F79FFF_93.9%)] bg-clip-text font-secondary text-sm leading-3 font-semibold text-transparent uppercase"
            onClick={button.onClick}
          >
            {button.text}
          </InteractiveContainer>
        </div>
      </div>
    </Portal>
  );
};
